import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'

export const RecommendedGoalsContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 24px;
`

export const RecommendedGoal = styled(Box)`
  border: 1px solid ${colors.interactive.borderFocusOrange};
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: 160px;
  position: relative;
  padding: 16px;
`

export const Title = styled(Typography)`
  ${typography.up1.regularSerif};
`

export const CheckboxContainer = styled(Box)`
  position: absolute;
  right: 10px;
  top: 10px;
`
